module.exports = __webpack_public_path__ + "static/media/iphone_13_mini_green.c5ae501a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_mini_green.png
// module id = 2110
// module chunks = 0